import { ICarTypesProps } from '@allesauto/core/filterBoxCarTypes';
import Headline from '@allesauto/core/headline';
import { sbEditable } from '@storyblok/storyblok-editable';
import clsx from 'clsx';
import React from 'react';

import FilterBoxItem from './FilterboxItem/index.tsx';

enum Colors {
  GREY = 'GREY',
  GREEN = 'GREEN',
  PURPLE = 'PURPLE',
  WHITE = 'WHITE',
  BLACK = 'BLACK',
}

interface FilterBoxIndividualProps {
  headline: string;
  headlineTag: 2 | 3 | 4;
  headlineFontSize: 'title' | 'headline2' | 'headline3' | 'headline4';
  headlineColor: Colors;
  background: Colors;
  items: ICarTypesProps[];
  filterCarIndividualItems: ICarTypesProps[];
  _uid: string;
  component: string;
}

const cssClasses = {
  container:
    'pt-[32px] pb-[40px] px-[16px] lg:px-[76px] lg:pt-[70px] lg:pb-[98.5px]',
  boxContainer:
    'mt-[26px] lg:mt-[60px] grid gap-[8px] grid-cols-2 lg:grid-cols-6',
};

const theme = {
  [Colors.GREY]: {
    background: 'bg-grey10 monochrome:bg-grey10',
    text: 'text-grey90 monochrome:text-grey90',
  },
  [Colors.GREEN]: {
    background: 'bg-green60 monochrome:bg-green60',
    text: 'text-green60 monochrome:text-green60',
  },
  [Colors.PURPLE]: {
    background: 'bg-purple80 monochrome:bg-purple80',
    text: 'text-purple80 monochrome:text-purple80',
  },
  [Colors.WHITE]: {
    background: 'bg-white monochrome:bg-white',
    text: 'text-white monochrome:text-white',
  },
  [Colors.BLACK]: {
    background: 'bg-black monochrome:bg-black',
    text: 'text-black monochrome:text-black',
  },
};

const FilterBoxIndividual = (props: FilterBoxIndividualProps) => {
  const {
    headline,
    headlineColor,
    headlineTag,
    background,
    headlineFontSize,
    filterCarIndividualItems,
    items,
  } = props;

  function getItem(id: string) {
    const item = filterCarIndividualItems.find(
      (value: ICarTypesProps) => value._uid === id
    );
    return item;
  }

  function getPrice(id?: string) {
    if (!id) return 0;

    const item = getItem(id);

    return item?.price ?? 0;
  }

  function getOffersCount(id?: string) {
    if (!id) return 0;
    const item = getItem(id);

    return item?.offersAmount ?? 0;
  }

  return (
    <section
      className={clsx(cssClasses.container, theme[background].background)}
      {...sbEditable(props)}
    >
      <Headline
        headlineTag={headlineTag}
        headlineText={headline}
        headlineColor={theme[headlineColor].text}
        headlineClassName={`text-${headlineFontSize}`}
      />
      <div className={cssClasses.boxContainer}>
        {items.map((item) => (
          <FilterBoxItem
            key={item._uid}
            name={item.description}
            icon={item.carType}
            availableCars={getOffersCount(item._uid)}
            startingPrice={getPrice(item._uid)}
            searchUrl={item.searchUrl}
          />
        ))}
      </div>
    </section>
  );
};

export default FilterBoxIndividual;
